import {UserWebservice} from './webservices/user.webservice';
import {AuthService} from './auth.service';
import {Router} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {SessionService} from './session.service';

@Injectable({
    providedIn: 'root'
})
export class LogoutService {
    private readonly userService = inject(UserWebservice);
    private readonly authService = inject(AuthService);
    private readonly sessionService = inject(SessionService);
    private readonly router = inject(Router);


    logout() {
        this.userService.currentUser = null;
        this.authService.signOutUser();
        this.sessionService.logout();
        this.router.navigate(['/login']);
    }

}
